import { ISchoolModel } from "../models/ISchoolModel";
import { FacilitatorSchoolControlState } from "./facilitatorSchoolModel";

export const getFacilitatorSchoolControlState =
    (values: ISchoolModel): FacilitatorSchoolControlState => {

        let controlState = new FacilitatorSchoolControlState();
        controlState.userName.label.userName = 'User Name';
        controlState.email.label.email = 'Email Id';
        controlState.password.label.password = 'Password';
        controlState.address.label.address = 'Address';
        controlState.mobileNumber.label.mobileNumber = 'Mobile Number';
        controlState.schoolName.label.schoolName = 'School Name';
        controlState.foundationPrograms.label.foundationPrograms = 'Foundation Programs';
        controlState.olympiadExams.label.olympiadExams = 'Olympiad Exams';
        controlState.chairmanName.label.chairmanName = 'Name';
        controlState.chairmanWhatsAppContact.label.chairmanWhatsAppContact = 'WhatsApp Contact';
        controlState.principalName.label.principalName = 'Name';
        controlState.principalWhatsAppContact.label.principalWhatsAppContact = 'WhatsApp Contact';
        controlState.programInChargeName.label.programInChargeName = 'Name';
        controlState.programInchargeWhatsAppContact.label.programInchargeWhatsAppContact = 'WhatsApp Contact';



        return controlState;
    };



